import { render, staticRenderFns } from "./PosDevices.vue?vue&type=template&id=46b8887a"
import script from "./PosDevices.vue?vue&type=script&lang=js"
export * from "./PosDevices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports